<ng-container *transloco="let _t">

<ol class="header-aligned"
	*ngIf="gd.selectedBuildings.length>0 else nothing">
	<li *ngFor="let building of gd.selectedBuildings">
		<building-listitem [model]="building"></building-listitem>
	</li>
</ol>

<ng-template #nothing>
<div class="header-aligned">
	<h2>{{ _t('list-buildings-h2-0') }}</h2>
	<h3>{{ _t('list-buildings-h3-0') }}</h3>
</div>
	
</ng-template>


</ng-container>